import { render } from "./ProductDevForm.vue?vue&type=template&id=7430cef1&scoped=true&ts=true"
import script from "./ProductDevForm.vue?vue&type=script&lang=ts"
export * from "./ProductDevForm.vue?vue&type=script&lang=ts"

import "./ProductDevForm.vue?vue&type=style&index=0&id=7430cef1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7430cef1"]])

export default __exports__